// extracted by mini-css-extract-plugin
export var button = "_ls-0";